/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:126eb09a-0776-4efa-a494-459f39dfba8a",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_zu6SCZQFR",
    "aws_user_pools_web_client_id": "nukjcru1jkpf8vght9e2paeds",
    "oauth": {}
};


export default awsmobile;